<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
<div class="relative">

  <div class="vx-navbar-wrapper" :class="classObj">

    <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">
      <!-- SM - OPEN SIDEBAR BUTTON -->
      <feather-icon class="sm:inline-flex 2xl:hidden cursor-pointer p-2 pl-0 -ml-2 sm:-ml-1" icon="MenuIcon" @click.stop="showSidebar" />




  

      <a v-if="!$store.getters['dash/isCollaborator']" :key="'sdaf'+btnKeys" @click.prevent="chatToUs" href="" class="mr-1">Get Help</a>
      <feather-icon v-if="!$store.getters['dash/isCollaborator']" icon="HelpCircleIcon" svgClasses="stroke-current text-primary w-5 h-5"
      />



      <div class="pl-4 ml-4 border-0 border-solid border-grey-light md:border-l" v-if="!$store.getters['dash/isCollaborator']">
        <p class="mr-4 hidden md:inline-block" v-if="$store.getters['dash/subscription'].planString">
          {{ $store.getters['dash/subscription'].planString }}
        </p>
      </div>


      <div class="" v-if="$store.getters['dash/isCollaborator']">
        <p class="mr-4 hidden md:inline-block">
          <vx-tooltip position="bottom" text="You have been invited to collaborate on this account.">
            Collaborator account
          </vx-tooltip>
        </p>
      </div>


      <vs-dropdown vs-custom-content v-if="($store.getters['dash/subscription'].isAppSumo && !$store.getters['dash/agency'].isAgency) && !$store.getters['dash/isCollaborator']">
        <a href="https://appsumo.com/marketplace-feedbacklink/#reviews" target="_blank">
          <p class="mr-4 pl-4 hidden md:inline-block border-0 border-solid border-grey-light md:border-l cursor-pointer">
            <img src="@/assets/images/misc/taco.png" class="h-5 mt-1" />
          </p>
        </a>
        <vs-dropdown-menu class="dropdown-login w-118">
          <div class="p-2">
            <h4 class="font-semibold text-center my-4 text-primary">Thank you, Sumoling!</h4>
            <div class="overflow-auto relative max-w-sm mx-auto my-2" style="min-height: 10.5rem;">
              <div class="float-left w-3/12">
                <img src="@/assets/images/misc/ctorcircle.png" class="w-full" />
                <p class="text-sm text-light text-center">Founder</p>
              </div>
              <div class="float-left w-9/12 absolute" style="left: 25%; top: 50%; transform: translateY(-50%); -webkit-transform: translateY(-50%); -moz-transform: translateY(-50%); ; -o-transform: translateY(-50%);">
                <p class="text-left pl-4">We hope you like Feedback Link! We're super excited to have you. Please get in touch if there's anything - <a href="mailto:pieter@feedback.link">pieter@feedback.link</a></p>
              </div>
            </div>
            <vs-divider/>
            <h3 class="font-medium text-center my-8">Review Us</h3>
            <p class="w-80 text-center mx-auto">We <span class="font-medium">live & breathe</span> on your feedback & reviews! Please don't forget to let us know what you think on AppSumo.</p>
            <vs-button href="https://appsumo.com/marketplace-feedbacklink/#reviews" target="_blank" type="flat" class="w-full my-5">
              <span class="block font-medium text-lg my-2">Review on AppSumo</span>
              <img class="h-5 md:h-10 block mx-auto inline-block" src="@/assets/images/misc/taco.png" />
            </vs-button>
          </div>
        </vs-dropdown-menu>

      </vs-dropdown>




      <vs-spacer />

      <profile-drop-down />

    </vs-navbar>
  </div>
</div>
</template>


<script>
//<a :href="$store.getters['dash/feedbackURLTest']" target="_blank" class="border-0 md:border-r border-solid border-grey-light pr-4 hidden md:inline-block">{{ $store.getters['dash/feedbackURL'] }}</a>

import ProfileDropDown from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-vertical',
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  data() {
    return {
      btnKeys: 0      
    }
  },
  components: {
    ProfileDropDown
  },
  computed: {
    navbarColorLocal() {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor() {
      return {
        'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
      }
    },
    windowWidth() {
      return this.$store.state.windowWidth
    },
    // NAVBAR STYLE
    classObj() {
      if (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth) return 'navbar-full'
    }
  },
  methods: {    
    showSidebar() {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
    
  }
}
</script>
